var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsBookmarkOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19.057V5a1 1 0 00-1-1H7a1 1 0 00-1 1v14.057l5.419-3.87a1 1 0 011.162 0L18 19.056zm-6-1.828l-6.419 4.585A1 1 0 014 21V5a3 3 0 013-3h10a3 3 0 013 3v16a1 1 0 01-1.581.814L12 17.229z",
    fill: "currentColor"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGwtcnVsZT0ibm9uemVybyIgZmlsbD0ibm9uZSI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xOCAxOS4wNTdWNWExIDEgMCAwIDAtMS0xSDdhMSAxIDAgMCAwLTEgMXYxNC4wNTdsNS40MTktMy44N2ExIDEgMCAwIDEgMS4xNjIgMEwxOCAxOS4wNTZ6bS02LTEuODI4LTYuNDE5IDQuNTg1QTEgMSAwIDAgMSA0IDIxVjVhMyAzIDAgMCAxIDMtM2gxMGEzIDMgMCAwIDEgMyAzdjE2YTEgMSAwIDAgMS0xLjU4MS44MTRMMTIgMTcuMjI5eiIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgIconsBookmarkOutlined as ReactComponent };